{
  "name": "outline",
  "private": true,
  "license": "Business Source License 1.1",
  "main": "index.js",
  "scripts": {
    "clean": "rimraf build",
    "copy:i18n": "mkdir -p ./build/shared/i18n && cp -R ./shared/i18n/locales ./build/shared/i18n",
    "build:i18n": "i18next --silent '{shared,app,server,plugins}/**/*.{ts,tsx}' && yarn copy:i18n",
    "build:server": "node ./build.js",
    "build": "yarn clean && yarn vite:build && yarn build:i18n && yarn build:server",
    "start": "node ./build/server/index.js",
    "dev": "NODE_ENV=development yarn concurrently -n api,collaboration  -c \"blue,magenta\" \"node --inspect=0.0.0.0 build/server/index.js --services=cron,collaboration,websockets,admin,web,worker\"",
    "dev:backend": "NODE_ENV=development nodemon --quiet --exec \"yarn build:server && yarn dev\" -e js,ts,tsx --watch server --watch shared --watch plugins --watch .env --watch .env.local --watch .env.development --ignore \"shared/components/**/*.tsx?\" --ignore \"plugins/client/**/*.tsx?\" --ignore \"**/*.test.ts\" --ignore data/ --ignore build/ --ignore app/ --ignore \"shared/editor/**\" --ignore server/migrations",
    "dev:watch": "NODE_ENV=development yarn concurrently -n backend,frontend \"yarn dev:backend\" \"yarn vite:dev\"",
    "lint": "oxlint --type-aware app server shared plugins",
    "lint:changed": "git diff --name-only --diff-filter=ACMRTUXB | grep -E '\\.(js|jsx|ts|tsx)$' | xargs -r oxlint",
    "format": "oxfmt app server shared plugins",
    "format:check": "oxfmt --check app server shared plugins",
    "prepare": "husky install",
    "postinstall": "yarn patch-package",
    "install-local-ssl": "node ./server/scripts/install-local-ssl.js",
    "release": "node ./server/scripts/release.js",
    "heroku-postbuild": "yarn build && yarn db:migrate",
    "db:create-migration": "sequelize migration:create",
    "db:create": "sequelize db:create",
    "db:migrate": "sequelize db:migrate",
    "db:rollback": "sequelize db:migrate:undo",
    "db:reset": "sequelize db:drop && sequelize db:create && sequelize db:migrate",
    "upgrade": "git fetch && git pull && yarn install && yarn heroku-postbuild",
    "test": "TZ=UTC vitest run",
    "test:app": "TZ=UTC vitest run --project app",
    "test:shared": "TZ=UTC vitest run --project shared-node --project shared-jsdom",
    "test:server": "TZ=UTC vitest run --project server",
    "test:watch": "TZ=UTC vitest",
    "vite:dev": "VITE_CJS_IGNORE_WARNING=true vite",
    "vite:build": "VITE_CJS_IGNORE_WARNING=true vite build",
    "vite:preview": "VITE_CJS_IGNORE_WARNING=true vite preview"
  },
  "funding": {
    "type": "GitHub Sponsors ❤",
    "url": "https://github.com/sponsors/outline"
  },
  "engines": {
    "node": ">=20.12 <21 || 22 || 24 <24.17.0 || 26 <26.3.1"
  },
  "repository": {
    "type": "git",
    "url": "git+ssh://git@github.com/outline/outline.git"
  },
  "browserslist": [
    "> 0.25%, not dead"
  ],
  "dependencies": {
    "@ai-sdk/azure": "^3.0.72",
    "@ai-sdk/openai": "^3.0.69",
    "@aws-sdk/client-s3": "^3.1126.0",
    "@aws-sdk/cloudfront-signer": "^3.1125.0",
    "@aws-sdk/lib-storage": "^3.1126.0",
    "@aws-sdk/s3-presigned-post": "^3.1126.0",
    "@aws-sdk/s3-request-presigner": "^3.1126.0",
    "@aws-sdk/signature-v4-crt": "^3.1126.0",
    "@benrbray/prosemirror-math": "^0.2.2",
    "@bull-board/api": "^6.21.3",
    "@bull-board/koa": "^6.21.3",
    "@bull-board/ui": "^6.21.3",
    "@css-inline/css-inline-wasm": "^0.20.2",
    "@dnd-kit/core": "^6.3.1",
    "@dnd-kit/modifiers": "^6.0.1",
    "@dnd-kit/sortable": "^7.0.2",
    "@dotenvx/dotenvx": "^1.75.1",
    "@emoji-mart/data": "^1.2.1",
    "@fast-csv/parse": "^5.0.7",
    "@firecrawl/pdf-inspector": "^1.11.2",
    "@fortawesome/fontawesome-svg-core": "^7.3.1",
    "@fortawesome/free-brands-svg-icons": "^7.3.1",
    "@fortawesome/free-solid-svg-icons": "^7.3.1",
    "@fortawesome/react-fontawesome": "^0.2.6",
    "@getoutline/react-roving-tabindex": "^3.2.4",
    "@gitbeaker/rest": "^43.8.0",
    "@hocuspocus/extension-redis": "1.1.3",
    "@hocuspocus/extension-throttle": "1.1.3",
    "@hocuspocus/provider": "1.1.3",
    "@hocuspocus/server": "1.1.3",
    "@juggle/resize-observer": "^3.4.0",
    "@koa/cors": "^5.0.0",
    "@langchain/core": "^0.3.80",
    "@langchain/textsplitters": "^0.1.0",
    "@linear/sdk": "^58.1.0",
    "@mermaid-js/layout-elk": "0.2.2",
    "@modelcontextprotocol/sdk": "^1.25.3",
    "@node-oauth/oauth2-server": "^5.3.0",
    "@node-saml/passport-saml": "^5.1.0",
    "@notionhq/client": "^2.3.0",
    "@octokit/auth-app": "^8.3.0",
    "@octokit/webhooks-types": "^7.6.1",
    "@outlinewiki/koa-passport": "^4.2.1",
    "@outlinewiki/passport-azure-ad-oauth2": "^0.1.0",
    "@radix-ui/react-collapsible": "^1.1.20",
    "@radix-ui/react-context-menu": "^2.3.7",
    "@radix-ui/react-dialog": "^1.1.23",
    "@radix-ui/react-direction": "^1.1.4",
    "@radix-ui/react-dropdown-menu": "^2.1.24",
    "@radix-ui/react-hover-card": "^1.1.23",
    "@radix-ui/react-one-time-password-field": "^0.1.16",
    "@radix-ui/react-popover": "^1.1.23",
    "@radix-ui/react-select": "^2.3.7",
    "@radix-ui/react-slot": "^1.3.0",
    "@radix-ui/react-switch": "^1.3.7",
    "@radix-ui/react-tabs": "^1.1.21",
    "@radix-ui/react-toolbar": "^1.1.19",
    "@radix-ui/react-tooltip": "^1.2.16",
    "@radix-ui/react-visually-hidden": "^1.2.11",
    "@sentry/node": "^10.73.0",
    "@sentry/react": "^10.73.0",
    "@simplewebauthn/browser": "^13.3.0",
    "@simplewebauthn/server": "^13.3.2",
    "@tanstack/react-table": "^8.21.3",
    "@tanstack/react-virtual": "^3.14.9",
    "@types/form-data": "^2.5.2",
    "@types/mailparser": "^3.4.6",
    "@types/pako": "^2.0.4",
    "@types/sanitize-filename": "^1.6.3",
    "@vitejs/plugin-react": "^6.0.5",
    "addressparser": "^1.0.1",
    "ai": "^6.0.200",
    "async-sema": "^3.1.1",
    "bull": "^4.16.5",
    "chrono-node": "^2.9.1",
    "class-validator": "^0.15.1",
    "command-score": "^0.1.2",
    "compressorjs": "^1.3.0",
    "content-disposition": "^0.5.4",
    "cookie": "^0.7.2",
    "copy-to-clipboard": "^3.3.3",
    "core-js": "^3.49.0",
    "crypto-js": "^4.2.0",
    "date-fns": "^3.6.0",
    "dd-trace": "^5.123.0",
    "diff": "^5.2.2",
    "domino": "^2.1.6",
    "email-providers": "^1.14.0",
    "emoji-mart": "^5.6.0",
    "emoji-regex": "^10.6.0",
    "es-toolkit": "^1.47.1",
    "es6-error": "^4.1.1",
    "fast-deep-equal": "^3.1.3",
    "fetch-retry": "^5.0.6",
    "form-data": "^4.0.6",
    "fractional-index": "^1.0.0",
    "framer-motion": "^6.5.1",
    "franc": "^6.2.0",
    "fs-extra": "^11.3.6",
    "fuse.js": "^7.5.0",
    "fuzzy-search": "^3.2.1",
    "glob": "^11.1.0",
    "hot-shots": "^12.1.0",
    "http-errors": "2.0.1",
    "https-proxy-agent": "^7.0.6",
    "i18next": "^22.5.1",
    "i18next-fs-backend": "^2.6.7",
    "i18next-http-backend": "^3.0.6",
    "invariant": "^2.2.4",
    "ioredis": "^5.11.1",
    "ip-filter": "^3.0.5",
    "ipaddr.js": "^2.4.0",
    "is-printable-key-event": "^1.0.0",
    "iso-639-3": "^3.0.1",
    "javascript-obfuscator": "^4.2.2",
    "js-yaml": "^4.3.2",
    "jsdom": "^22.1.0",
    "jsonwebtoken": "^9.0.3",
    "katex": "^0.17.0",
    "kbar": "^1.0.0",
    "koa": "^3.0.3",
    "koa-body": "^6.0.1",
    "koa-compress": "^5.2.2",
    "koa-helmet": "^6.1.0",
    "koa-logger": "^3.2.1",
    "koa-mount": "^4.2.0",
    "koa-router": "7.4.0",
    "koa-send": "5.0.1",
    "koa-sslify": "5.0.1",
    "koa-useragent": "^4.1.0",
    "mailparser": "^3.9.20",
    "mammoth": "^1.11.0",
    "markdown-it": "^14.3.0",
    "markdown-it-container": "^3.0.0",
    "markdown-it-emoji": "^3.0.0",
    "mermaid": "11.17.1",
    "mime-types": "^3.0.2",
    "mobx": "^6.16.1",
    "mobx-react": "^9.2.2",
    "mobx-utils": "^6.1.1",
    "natural-sort": "^1.0.0",
    "node-fetch": "2.7.0",
    "nodemailer": "^10.0.0",
    "octokit": "^5.0.5",
    "openai": "^6.45.0",
    "outline-icons": "^4.6.0",
    "oy-vey": "^0.12.1",
    "pako": "^2.1.0",
    "passport": "^0.7.0",
    "passport-google-oauth2": "^0.2.0",
    "passport-oauth2": "^1.8.0",
    "passport-slack-oauth2": "^1.2.0",
    "patch-package": "^8.0.1",
    "pg": "^8.20.0",
    "pg-tsquery": "^8.4.2",
    "pgvector": "^0.1.5",
    "pluralize": "^8.0.0",
    "png-chunks-extract": "^1.0.0",
    "polished": "^4.3.1",
    "prosemirror-changeset": "2.4.1",
    "prosemirror-codemark": "^0.4.2",
    "prosemirror-commands": "^1.7.1",
    "prosemirror-dropcursor": "^1.8.3",
    "prosemirror-gapcursor": "^1.4.1",
    "prosemirror-history": "^1.5.0",
    "prosemirror-inputrules": "^1.5.1",
    "prosemirror-keymap": "^1.2.3",
    "prosemirror-markdown": "^1.13.4",
    "prosemirror-model": "^1.25.4",
    "prosemirror-schema-list": "^1.5.1",
    "prosemirror-state": "^1.4.4",
    "prosemirror-tables": "^1.8.5",
    "prosemirror-transform": "1.10.5",
    "prosemirror-view": "^1.41.8",
    "proxy-from-env": "^1.1.0",
    "query-string": "^9.5.0",
    "rate-limiter-flexible": "^2.4.2",
    "react": "^18.3.1",
    "react-avatar-editor": "^13.0.2",
    "react-colorful": "^5.8.0",
    "react-day-picker": "^8.10.2",
    "react-dnd": "^16.0.1",
    "react-dnd-html5-backend": "^16.0.1",
    "react-dom": "^18.3.1",
    "react-dropzone": "^11.7.1",
    "react-helmet-async": "^2.0.5",
    "react-hook-form": "^7.85.0",
    "react-i18next": "^12.3.1",
    "react-is": "^18.3.1",
    "react-merge-refs": "^2.1.1",
    "react-portal": "^4.3.0",
    "react-remove-scroll": "^2.7.2",
    "react-router-dom": "^5.3.4",
    "react-use-measure": "^2.1.7",
    "react-virtualized-auto-sizer": "^1.0.26",
    "react-waypoint": "^10.3.0",
    "react-window": "^1.8.11",
    "react-zoom-pan-pinch": "^3.7.0",
    "redlock": "^5.0.0-beta2",
    "reflect-metadata": "^0.2.2",
    "refractor": "^3.6.0",
    "resolve-path": "^1.4.0",
    "sanitize-filename": "^1.6.4",
    "scroll-into-view-if-needed": "^3.1.0",
    "semver": "^7.8.1",
    "sequelize": "^6.37.8",
    "sequelize-cli": "^6.6.5",
    "sequelize-strict-attributes": "^1.0.2",
    "sequelize-typescript": "^2.1.6",
    "slug": "^5.3.0",
    "slugify": "^1.6.9",
    "socket.io": "^4.8.3",
    "socket.io-client": "^4.8.3",
    "socket.io-redis": "^6.1.1",
    "sonner": "^2.0.8",
    "stoppable": "^1.1.0",
    "string-replace-to-array": "^2.1.1",
    "styled-components": "^5.3.11",
    "styled-components-breakpoint": "^2.1.1",
    "styled-normalize": "^8.1.1",
    "throng": "^5.0.0",
    "tiny-cookie": "^2.5.1",
    "tmp": "^0.2.6",
    "tunnel-agent": "^0.6.0",
    "ukkonen": "^2.2.0",
    "umzug": "^3.8.3",
    "utility-types": "^3.11.0",
    "uuid": "^11.1.1",
    "validator": "13.15.35",
    "vaul": "^1.1.2",
    "vite": "^8.1.5",
    "vite-plugin-pwa": "1.3.0",
    "winston": "^3.17.0",
    "ws": "^7.5.13",
    "y-prosemirror": "^1.3.7",
    "y-protocols": "^1.0.7",
    "yauzl": "^3.3.1",
    "yazl": "^3.3.1",
    "yjs": "^13.6.31",
    "zod": "^4.5.4"
  },
  "devDependencies": {
    "@faker-js/faker": "^10.5.0",
    "@relative-ci/agent": "^4.3.1",
    "@swc/cli": "^0.8.1",
    "@swc/core": "^1.15.32",
    "@types/addressparser": "^1.0.3",
    "@types/cookie": "0.6.0",
    "@types/crypto-js": "^4.2.2",
    "@types/diff": "^5.0.9",
    "@types/dotenv": "^8.2.3",
    "@types/emoji-regex": "^9.2.2",
    "@types/escape-html": "^1.0.4",
    "@types/express-useragent": "^1.0.5",
    "@types/formidable": "^2.0.6",
    "@types/fs-extra": "^11.0.4",
    "@types/fuzzy-search": "^2.1.5",
    "@types/glob": "^8.0.1",
    "@types/google.analytics": "^0.0.46",
    "@types/invariant": "^2.2.37",
    "@types/ioredis-mock": "^8.2.8",
    "@types/js-yaml": "^4.0.9",
    "@types/jsdom": "^28.0.1",
    "@types/jsonwebtoken": "^8.5.9",
    "@types/katex": "^0.16.8",
    "@types/koa": "^2.15.1",
    "@types/koa-compress": "^4.0.7",
    "@types/koa-logger": "^3.1.5",
    "@types/koa-mount": "^4.0.5",
    "@types/koa-router": "^7.4.9",
    "@types/koa-send": "^4.1.6",
    "@types/koa-sslify": "^4.0.6",
    "@types/koa-useragent": "^2.1.2",
    "@types/koa__cors": "^5.0.0",
    "@types/markdown-it": "^14.1.2",
    "@types/markdown-it-container": "^2.0.11",
    "@types/markdown-it-emoji": "^3.0.1",
    "@types/mime-types": "^3.0.1",
    "@types/natural-sort": "^0.0.24",
    "@types/node": "20.19.43",
    "@types/node-fetch": "^2.6.13",
    "@types/passport-oauth2": "^1.8.0",
    "@types/passport-strategy": "^0.2.35",
    "@types/pluralize": "^0.0.33",
    "@types/png-chunks-extract": "^1.0.2",
    "@types/proxy-from-env": "^1.0.4",
    "@types/quoted-printable": "^1.0.2",
    "@types/react": "18.3.31",
    "@types/react-avatar-editor": "^13.0.4",
    "@types/react-dom": "^18.3.7",
    "@types/react-helmet": "^6.1.11",
    "@types/react-portal": "^4.0.7",
    "@types/react-router-dom": "^5.3.3",
    "@types/react-virtualized-auto-sizer": "^1.0.8",
    "@types/react-window": "^1.8.8",
    "@types/readable-stream": "^4.0.24",
    "@types/redis-info": "^3.0.3",
    "@types/refractor": "^3.4.1",
    "@types/resolve-path": "^1.4.3",
    "@types/semver": "^7.7.1",
    "@types/sequelize": "^4.28.20",
    "@types/slug": "^5.0.9",
    "@types/stoppable": "^1.1.3",
    "@types/styled-components": "^5.1.36",
    "@types/throng": "^5.0.7",
    "@types/tmp": "^0.2.6",
    "@types/utf8": "^3.0.3",
    "@types/validator": "^13.15.10",
    "@types/xml2js": "^0.4.9",
    "@types/yauzl": "^2.10.3",
    "@types/yazl": "^3.3.1",
    "@vitest/ui": "^4.1.11",
    "browserslist-to-esbuild": "^1.2.0",
    "concurrently": "^8.2.2",
    "discord-api-types": "^0.38.48",
    "fake-indexeddb": "^6.2.5",
    "husky": "^8.0.3",
    "i18next-parser": "^9.4.0",
    "ioredis-mock": "^8.13.1",
    "lint-staged": "^16.4.0",
    "msw": "^2.14.2",
    "nodemon": "^3.1.14",
    "oxfmt": "0.66.0",
    "oxlint": "1.81.0",
    "oxlint-tsgolint": "7.0.2001",
    "postinstall-postinstall": "^2.1.0",
    "react-refresh": "^0.18.0",
    "rimraf": "^6.1.3",
    "rollup-plugin-webpack-stats": "^3.1.3",
    "terser": "^5.49.0",
    "typescript": "^6.0.3",
    "unplugin-swc": "^1.5.11",
    "vite-tsconfig-paths": "^6.1.1",
    "vitest": "^4.1.11"
  },
  "resolutions": {
    "@types/react": "18.3.31",
    "@types/koa": "2.15.1",
    "prosemirror-transform": "1.10.5",
    "prismjs": "1.30.0",
    "zod": "^4.5.4",
    "@types/markdown-it": "14.1.2",
    "ip-address@npm:10.1.0": "^10.2.0",
    "minimatch@npm:9.0.1": "9.0.9",
    "lodash@npm:4.17.21": "^4.18.1",
    "i18next-parser/i18next": "^23.16.8",
    "fast-xml-builder@npm:^1.1.5": "^1.1.7",
    "langsmith@npm:^0.3.67": "^0.6.0",
    "ws@npm:~8.17.1": "^8.21.0",
    "uuid": "^11.1.1",
    "nodemailer@npm:9.0.0": "^9.0.1",
    "linkify-it@npm:5.0.1": "5.0.2",
    "deepmerge-ts@npm:^7.1.5": "^8.0.1"
  },
  "version": "1.10.1",
  "packageManager": "yarn@4.11.0"
}
